'use strict';
import { app } from '../../../bootstrap/core';
import UserImportService from './userImport.service'; 

import userImportComponent from './userImport.component';

app.component('userImportComponent', userImportComponent);
app.service('userImportService', UserImportService);
